import React, { useState } from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  NavbarItem,
  NavbarBurger,
  NavbarMenu,
  NavbarStart,
  NavbarEnd
} from 'bloomer';
import logo from '../img/logo.png';
import { firebaseApp } from '../firebase/firebase';
import Gravatar from 'react-gravatar';
import { useHistory } from 'react-router-dom';

export function NavTop({ user }: { user: firebase.User }) {
  const [active, setActive] = useState(false);
  const history = useHistory();

  return (
    <Container>
      <Navbar isTransparent style={{ background: 'transparent', color: '#fff' }}>
        <NavbarBrand>
          <NavbarItem hasTextColor="light">
            <img src={logo} style={{ marginRight: 5 }} alt="Logo" /> TBS Conversions KTM
          </NavbarItem>
          <NavbarBurger hasTextColor="light" isActive={active} onClick={() => setActive(!active)} />
        </NavbarBrand>
        <NavbarMenu isActive={active} onClick={() => setActive(!active)}>
          <NavbarStart>
            <NavbarItem href="/" onClick={e => navigateTo(e, history, '/')}>
              Bike Reports
            </NavbarItem>
            <NavbarItem href="/riders" onClick={e => navigateTo(e, history, '/riders')}>
              Riders &amp; Bikes
            </NavbarItem>
          </NavbarStart>
          <NavbarEnd>
            <NavbarItem
              hasTextColor="light"
              href="#/"
              onClick={e => {
                e.preventDefault();
                firebaseApp.auth().signOut();
              }}
            >
              Sign Out
            </NavbarItem>
            <NavbarItem
              hasTextColor="light"
              href="#/"
              onClick={e => {
                e.preventDefault();
                window.open('https://gravatar.com');
              }}
            >
              <Gravatar
                email={user.email!}
                size={64}
                rating="pg"
                default={'identicon'}
                style={{ borderRadius: '100%' }}
              />
            </NavbarItem>
          </NavbarEnd>
        </NavbarMenu>
      </Navbar>
    </Container>
  );
}

export function navigateTo(
  event: React.MouseEvent<HTMLElement, MouseEvent>,
  history: ReturnType<typeof useHistory>,
  url: string
) {
  event.preventDefault();
  history.push(url);
}
